import { render } from "./NewKeyResultForm.vue?vue&type=template&id=3343433f&scoped=true"
import script from "./NewKeyResultForm.vue?vue&type=script&lang=js"
export * from "./NewKeyResultForm.vue?vue&type=script&lang=js"

import "./NewKeyResultForm.vue?vue&type=style&index=0&id=3343433f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3343433f"

export default script